import styled from "@emotion/styled";
import * as React from "react";

import { Heading, SpacingToken } from "@livechat/design-system-react-components";

import { ITicket } from "interfaces/entities/ticket";
import { IAgent } from "store/entities/agents";
import { ITag } from "store/entities/tags";
import { ITeam } from "store/entities/teams";

import { MergedTicketSummary } from "./MergedTicketSummary";
import { TicketOption } from "./TicketOption";

interface ITicketsToMergeProps {
  ticketsToMerge: ITicket[];
  ticket: ITicket;
  setChildTickets: (ticketIds: string[]) => void;
  selectedChildTicketsIds: string[];
  isLoading: boolean;
  tags: ITag[];
  teams: ITeam[];
  agents: IAgent[];
}

export const TicketsToMergeSummary: React.FC<ITicketsToMergeProps> = ({
  ticket,
  ticketsToMerge,
  setChildTickets,
  selectedChildTicketsIds,
  tags,
  teams,
  agents,
}) => (
  <Wrapper>
    <SectionHeading size="xs">Preview of tickets selected for merging</SectionHeading>
    <TicketOption
      hasCheckbox={false}
      ticket={ticket}
      selectedChildTicketsIds={selectedChildTicketsIds}
      setChildTickets={setChildTickets}
    />
    <>
      <MergedTicketSummary
        ticket={ticket}
        selectedChildTickets={ticketsToMerge.filter(item => selectedChildTicketsIds.includes(item.id))}
        tags={tags}
        teams={teams}
        agents={agents}
      />
      <SectionHeading size="xs">Sub tickets ({selectedChildTicketsIds.length})</SectionHeading>
      {selectedChildTicketsIds.length &&
        ticketsToMerge
          .filter(item => selectedChildTicketsIds.find(child => child === item.id))
          .map(item => (
            <TicketOption
              hasIcon
              key={item.id}
              ticket={item}
              setChildTickets={setChildTickets}
              selectedChildTicketsIds={selectedChildTicketsIds}
            />
          ))}
    </>
  </Wrapper>
);

const Wrapper = styled.div`
  overflow: auto;
`;

const SectionHeading = styled(Heading)`
  margin: var(${SpacingToken.Spacing2}) 0;
`;
